import { useEffect } from 'react'

import { AnimatePresence, useCycle, m, LazyMotion } from 'motion/react'
import { MenuToggle } from 'lib/ui/Animations/MenuToggle'
import { useRouter } from 'next/router'
import { createStyles } from 'utils/css'
import theme from 'utils/theme'

const { spacing } = theme
const loadFeatures = () => import('utils/animations').then(res => res.default)

const MobileNav = ({ brandColor, children, offset = 8.2 }) => {
  const { asPath } = useRouter()
  const [isOpen, toggleOpen] = useCycle(false, true)

  const background = () =>
    createStyles(({ colors, size }) => ({
      borderRight: `1px solid ${colors.grey10}`,
      background: !brandColor ? colors.primary : colors.light,
      position: 'fixed',
      left: 0,
      bottom: 0,
      top: size(offset),
      zIndex: 1,
      textAlign: 'left',
      padding: isOpen && `${spacing(2)} 0`
    }))

  const content = () =>
    createStyles(({ justifications }) => ({
      height: '100%',
      flexDirection: 'column',
      justifyContent: justifications.between
    }))

  const sidebar = {
    open: {
      width: '50%',
      minWidth: '270px',
      padding: `${spacing(2)} 0`,

      transition: {
        type: 'tween' as const,
        duration: 0.5,
        delayChildren: 0.5
      }
    },
    closed: {
      width: 0,
      padding: 0,
      minWidth: 0,
      transition: {
        delay: 0.25,
        type: 'tween' as const
      }
    }
  }
  const menu = {
    closed: { display: 'none' },
    open: { display: 'flex' }
  }

  useEffect(() => {
    toggleOpen(0)
  }, [asPath])

  return (
    <LazyMotion features={loadFeatures}>
      <AnimatePresence initial={false}>
        <m.div initial={false} animate={isOpen ? 'open' : 'closed'}>
          <MenuToggle toggle={() => toggleOpen()} />

          <m.div css={background} variants={sidebar}>
            <m.div css={content} variants={menu}>
              {children}
            </m.div>
          </m.div>
        </m.div>
      </AnimatePresence>
    </LazyMotion>
  )
}

export default MobileNav
